// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__7GOQJ","image":"card_image__5wirC","custNrWrap":"card_custNrWrap__iyVno","custNr":"card_custNr__NJLeJ","barcode":"card_barcode__jHqdP"};